import gsap from 'gsap';

import { ANIMATION_HELPERS, ANIMATION_TYPE } from '../../const/animations.const';
import { VIDEO_RATIO } from '../../const/video.const';
import getWindowSize from '../../utils/getWindow.util';
import { toScreenXY } from '../utils/getScreenCoordinates';
import { getVimeoIframe } from '../utils/getVimeoIframe';
import { handleOpacity } from './opacity.animations';

const createVideo = (mesh: THREE.Mesh): void => {
	const video = getVimeoIframe(
		mesh.userData.videoId,
		mesh.userData.video.currentTime,
	);
	const container = document.querySelector('.c-container');
	container?.appendChild(video);
};

const createCloseButton = (onComplete: () => void) => {
	const close = document.getElementsByClassName('c-button--close')[0];
	close.classList.remove('c-button--hide');
	close.addEventListener('click', () => {
		const close = document.getElementsByClassName('c-button--close')[0];
		close.classList.add('c-button--hide');
		onComplete();
	});

	const menu = document.getElementsByClassName('js-button-menu')[0];
	menu.addEventListener('click', () => {
		const close = document.getElementsByClassName('c-button--close')[0];
		close.classList.add('c-button--hide');
		onComplete();
	});

	gsap.to('.c-logo', {
		scale: 1,
		duration: ANIMATION_HELPERS.duration,
		ease: ANIMATION_HELPERS.ease,
	});
};

const getRealRatio = (mesh: THREE.Mesh, camera: THREE.PerspectiveCamera): number => {
	// Calculate real size of current mesh in 3D space
	const left = mesh.position.clone();
	left.x = mesh.position.x - mesh.scale.x / 2;
	const right = mesh.position.clone();
	right.x = mesh.position.x + mesh.scale.x / 2;

	const realLeft = toScreenXY(left, camera);
	const realRight = toScreenXY(right, camera);
	const realWidth = realRight.x - realLeft.x;
	// Info(Katia) Don't know where this 1.11 comes from but it works
	const ratio = mesh.scale.x / realWidth / 1.11;

	return ratio;
};

export const animateVideoToFullscreen = (
	mesh: THREE.Mesh,
	camera: THREE.PerspectiveCamera,
	onComplete: () => void,
) => {
	const sizes = getWindowSize();

	mesh.userData.video.pause();
	createVideo(mesh);
	createCloseButton(onComplete);
	const ratio = getRealRatio(mesh, camera);

	// Calculate max width keeping the aspect ratio in mind
	let fullScreenWidth = sizes.width;
	if (VIDEO_RATIO * sizes.width > sizes.height) {
		fullScreenWidth = sizes.height / VIDEO_RATIO;
	}

	// Animate
	gsap.to(mesh.position, {
		x: 0 - (mesh?.parent?.position?.x || 0),
		y: 0 - (mesh?.parent?.position?.y || 0),
		z: 2,
		duration: ANIMATION_HELPERS.durationLarge,
		ease: ANIMATION_HELPERS.ease,
	});

	gsap.to(mesh.scale, {
		x: fullScreenWidth * ratio,
		y: fullScreenWidth * VIDEO_RATIO * ratio,
		z: 1,
		duration: ANIMATION_HELPERS.durationLarge,
		ease: ANIMATION_HELPERS.ease,
	});

	gsap.fromTo(
		'.c-video',
		{
			width: `${fullScreenWidth}px`,
			height: `${fullScreenWidth * VIDEO_RATIO}px`,
			opacity: 0,
		},
		{
			width: `${fullScreenWidth}px`,
			height: `${fullScreenWidth * VIDEO_RATIO}px`,
			opacity: 1,
			delay: ANIMATION_HELPERS.durationLarge,
			duration: ANIMATION_HELPERS.duration,
			ease: ANIMATION_HELPERS.ease,
			onComplete: () => {
				handleOpacity(
					mesh,
					ANIMATION_TYPE.OUT,
					ANIMATION_HELPERS.durationXLarge,
				);
			},
		},
	);
};
